<po-modal
  #modal
  p-title="Analisar feedback"
  p-size="xl"
  class="curation-main-modal"
  p-icon="po-icon-edit"
  [p-hide-close]="saving || discarding"
  [p-primary-action]="primaryAction"
  [p-secondary-action]="secondaryAction">

  <ng-container *ngIf="item">

    <div *ngIf="showReclassifyBanner" class="curation-reclassify-banner">
      <span class="po-icon po-icon-warning curation-reclassify-banner__icon"></span>
      Item descartado — selecione uma categoria e salve para reclassificá-lo como curado.
    </div>

    <div class="curation-modal-shell">
      <po-container>
        <div class="curation-summary">
          <div class="curation-summary__main">
            <div class="po-row">
              <po-tag
                class="curation-summary__tag"
                [p-value]="getResourceTypeLabel(item.resourceType)"
                p-color="#753399"
                p-inverse="true">
              </po-tag>
              <po-tag
                class="curation-summary__tag"
                [p-value]="getFindingKindLabel(item.findingKind)"
                p-color="#0c9abe"
                p-inverse="true">
              </po-tag>
              <po-tag
                *ngIf="isFinding"
                class="curation-summary__tag"
                [p-value]="snapshotSeverity"
                [p-type]="getSeverityType(snapshotSeverity)"
                p-inverse="true">
              </po-tag>
            </div>
            <h2 class="curation-summary__title" [title]="resourceLabel">{{ resourceLabel }}</h2>
          </div>

          <po-button
            p-kind="secondary"
            p-icon="po-icon-eye"
            p-label="Ver review original"
            (p-click)="openOriginalReview()">
          </po-button>
        </div>
      </po-container>

      <div class="po-row">
        <div [class]="showClassification ? 'po-md-8' : 'po-md-12'">
          <po-divider p-label="Identificação"></po-divider>

          <div class="po-row">
            <po-info
              *ngIf="fileName"
              class="po-md-6"
              p-label="Arquivo"
              p-orientation="vertical"
              [p-value]="fileName">
            </po-info>

            <po-info
              *ngIf="itemLanguage"
              class="po-md-3"
              p-label="Linguagem"
              p-orientation="vertical"
              [p-value]="itemLanguage">
            </po-info>

            <po-info
              *ngIf="filePath"
              class="po-md-12"
              p-label="Caminho"
              p-orientation="vertical"
              [p-value]="filePath">
            </po-info>

            <po-info
              *ngIf="isCurated && item?.curatedAt"
              class="po-md-4"
              p-label="Curado em"
              p-orientation="vertical"
              [p-value]="curatedAt">
            </po-info>
          </div>

          <ng-container *ngIf="isFinding">
            <po-divider p-label="Detalhes do achado"></po-divider>

            <div class="po-row">
              <po-info
                class="po-md-3"
                p-label="Linha"
                p-orientation="vertical"
                [p-value]="snapshotLine">
              </po-info>

              <div class="po-md-9">
                <label class="curation-field-label">Severidade</label>
                <po-tag
                  [p-value]="snapshotSeverity"
                  [p-type]="getSeverityType(snapshotSeverity)"
                  p-inverse="true">
                </po-tag>
              </div>

              <po-info
                class="po-md-12"
                p-label="Descrição"
                p-orientation="vertical"
                [p-value]="snapshotDescription">
              </po-info>

              <po-info
                *ngIf="snapshotAction"
                class="po-md-12"
                p-label="Ação sugerida"
                p-orientation="vertical"
                [p-value]="snapshotAction">
              </po-info>
            </div>

            <div *ngIf="snapshotCode">
              <label class="curation-field-label">Código</label>
              <pre class="curation-code">{{ snapshotCode }}</pre>
            </div>
          </ng-container>

          <ng-container *ngIf="hasFeedbacks">
            <po-divider [p-label]="feedbackCountLabel"></po-divider>

            <po-table
              class="curation-feedback-table"
              [p-columns]="feedbackColumns"
              [p-items]="feedbacks"
              p-spacing="small"
              p-hide-columns-manager="true"
              [p-hide-table-search]="true">

              <ng-template p-table-cell-template let-column="column" let-row="row">
                <po-tag
                  *ngIf="column.property === 'resolution'"
                  [p-value]="getResolutionLabel(row.resolution)"
                  [p-color]="getResolutionColor(row.resolution)"
                  [p-icon]="getResolutionIcon(row.resolution)"
                  p-inverse="true">
                </po-tag>
              </ng-template>
            </po-table>
          </ng-container>
        </div>

        <div class="po-md-4" *ngIf="showClassification">
          <po-container>
            <po-divider p-label="Classificação"></po-divider>

            <po-select
              name="category"
              p-label="Categoria"
              p-placeholder="Selecione a categoria"
              [p-required]="true"
              [p-options]="categoryOptions"
              [ngModel]="category"
              (p-change)="onCategoryChange($event)">
            </po-select>

            <po-select
              *ngIf="asksDueSeverity"
              name="dueSeverity"
              p-label="Severidade devida"
              [p-help]="'O achado saiu como ' + snapshotSeverity + '. Em que nível deveria ter saído?'"
              p-placeholder="Selecione a severidade"
              [p-required]="true"
              [p-options]="dueSeverityOptions"
              [(ngModel)]="dueSeverity">
            </po-select>

            <po-info
              *ngIf="needsSeverityTag && !asksDueSeverity"
              p-label="Severidade"
              p-orientation="vertical"
              [p-value]="'Correto inclui a severidade: ' + snapshotSeverity + ' estava certa. Se o nível estava errado, use Severidade errada.'">
            </po-info>

            <po-info
              p-label="Alavanca de melhoria (lever)"
              p-orientation="vertical"
              [p-value]="leverLabel">
            </po-info>

            <po-info
              *ngIf="categoryHint"
              p-label="Quando usar"
              p-orientation="vertical"
              [p-value]="categoryHint">
            </po-info>

            <po-info
              *ngIf="leverHint"
              p-label="Sobre a alavanca"
              p-orientation="vertical"
              [p-value]="leverHint">
            </po-info>

            <po-textarea
              name="comment"
              p-label="Comentário"
              p-placeholder="Comentário da curadoria"
              p-rows="5"
              [(ngModel)]="comment">
            </po-textarea>
          </po-container>
        </div>
      </div>

    </div>

  </ng-container>

</po-modal>

<!-- Detalhe do review original, embutido em modo modal (sem sair da curadoria) -->
<po-modal
  #reviewModal
  p-title="Review original"
  p-size="xl"
  class="curation-review-original-modal"
  [p-primary-action]="reviewModalCloseAction"
  p-click-out="true">
  <app-review-detail [modalMode]="true" [sourceOnly]="true"></app-review-detail>
</po-modal>
